import { render, staticRenderFns } from "./add-edit-user.vue?vue&type=template&id=8559b56c&scoped=true&"
import script from "./add-edit-user.vue?vue&type=script&lang=js&"
export * from "./add-edit-user.vue?vue&type=script&lang=js&"
import style0 from "./add-edit-user.vue?vue&type=style&index=0&id=8559b56c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8559b56c",
  null
  
)

export default component.exports